// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__overlay--NHU03 {
  background-color: rgba(0, 0, 0, 0.45);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__sliderTop--OgUKW {
  display: block;
  width: 100vw;
  height: 100vh;
  padding: 24px 24px 32px;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__sliderBorder--SFpDs {
  position: relative;
  height: calc(100%);
  width: calc(100%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__info--mMMFh {
  color: white;
  font-size: 14px;
  position: absolute;
  left: 0;
  width: 100%;
  bottom: -22px;
  text-align: center;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__nameBox--Gmg8C {
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: center;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__name--JRRza {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 16px;
  text-align: center;
  padding: 8px 16px;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__obutton--QsQK2 {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  position: absolute;
  z-index: 1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__closeButton--Qt1CU {
  width: 48px;
  height: 48px;
  right: 0;
  top: 0;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.45);
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__obutton--QsQK2:hover {
  background-color: rgba(0, 0, 0, 0.75);
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__vbutton--O2Z2i {
  width: 48px;
  height: 48px;
  top: calc(50% - 30px);
  border-radius: 50%;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__leftButton--Tx2LP {
  width: 48px;
  height: 48px;
  top: calc(50% - 30px);
  border-radius: 50%;
  left: 0;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__rightButton--wNIAc {
  width: 48px;
  height: 48px;
  top: calc(50% - 30px);
  border-radius: 50%;
  right: 0;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__frame--noeAa {
  max-width: 100%;
  max-height: 100%;
  transition: transform 0.2s ease;
  transition: opacity 0.2s ease;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__spin--CgY4Q {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/image/ImgList/ImgListDetails.module.less"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AACF;AAEA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AAAF;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;AAKA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAHF;AAMA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;AAJF;AAMA;EACE,oCAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAJF;AAOA;EACE,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AALF;AAQA;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;EACA,kBAAA;EACA,qCAAA;AANF;AASA;EACE,qCAAA;AAPF;AAUA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AARF;AAWA;EANE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EAKA,OAAA;AANF;AASA;EAXE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EAUA,QAAA;AAJF;AAOA;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,6BAAA;AALF;AAQA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANF","sourcesContent":[".overlay {\n  background-color: rgba(0, 0, 0, 0.45);\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 10000;\n}\n\n.sliderTop {\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  padding: 24px 24px 32px;\n}\n\n.sliderBorder {\n  position: relative;\n  height: calc(100%);\n  width: calc(100%);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.info {\n  color: white;\n  font-size: 14px;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  bottom: -22px;\n  text-align: center;\n}\n\n.nameBox {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 0;\n  display: flex;\n  justify-content: center;\n}\n.name {\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 16px;\n  text-align: center;\n  padding: 8px 16px;\n}\n\n.obutton {\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  position: absolute;\n  z-index: 1;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n}\n\n.closeButton {\n  width: 48px;\n  height: 48px;\n  right: 0;\n  top: 0;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.45);\n}\n\n.obutton:hover {\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.vbutton {\n  width: 48px;\n  height: 48px;\n  top: calc(50% - 30px);\n  border-radius: 50%;\n}\n\n.leftButton {\n  .vbutton();\n  left: 0;\n}\n\n.rightButton {\n  .vbutton();\n  right: 0;\n}\n\n.frame {\n  max-width: 100%;\n  max-height: 100%;\n  transition: transform 0.2s ease;\n  transition: opacity 0.2s ease;\n}\n\n.spin {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__overlay--NHU03`,
	"sliderTop": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__sliderTop--OgUKW`,
	"sliderBorder": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__sliderBorder--SFpDs`,
	"info": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__info--mMMFh`,
	"nameBox": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__nameBox--Gmg8C`,
	"name": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__name--JRRza`,
	"obutton": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__obutton--QsQK2`,
	"closeButton": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__closeButton--Qt1CU`,
	"vbutton": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__vbutton--O2Z2i`,
	"leftButton": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__leftButton--Tx2LP`,
	"rightButton": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__rightButton--wNIAc`,
	"frame": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__frame--noeAa`,
	"spin": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgListDetails-module__spin--CgY4Q`
};
export default ___CSS_LOADER_EXPORT___;
